import { useQuery as useReactQuery } from '@tanstack/react-query';

import { request } from '../server/request';

export const useQuery = ({
  method,
  url,
  initialData,
  language,
  params = {},
  options = {},
  fetchOptions = {},
}) => {
  const {
    data: { data },
    isFetching,
    isLoading,
    isError,
    error,
  } = useReactQuery({
    queryKey: [url, language, params],
    queryFn: () =>
      request(url, method, params, fetchOptions).then(({ data }) => data),
    initialData: initialData ? { data: initialData } : undefined,
    staleTime: 0,
    refetchOnMount: false,
    keepPreviousData: false,
    ...options,
  });
  return { data, isFetching, isLoading, isError, error };
};
